import { I18nSchema } from "./I18nSchema";
import { I18nEnglish } from "./I18nEnglish";

export const I18nRussian: I18nSchema = {
  ...I18nEnglish,
  //Navbar
  TITTLE_NAVBAR_MENU_ORDERS: "Заказы",
  TITTLE_NAVBAR_MENU_ROUTES: "Маршруты",
  TITTLE_NAVBAR_MENU_ROUTES_SETTING: "Настройки маршрутизации",
  TITTLE_NAVBAR_MENU_ANALYTICS: "Аналитика",
  TITTLE_NAVBAR_MENU_ANALYTICS_MILEAGE: "Пробеги TC",
  TITTLE_NAVBAR_MENU_ANALYTICS_TO_GMC: "ТО ва ГМС",
  TITTLE_NAVBAR_MENU_SETTING: "Настройки",
  TITTLE_NAVBAR_MENU_SETTING_MOBILE_CLIENT: "Транспорт",
  TITTLE_NAVBAR_MENU_SETTING_DRIVERS: "Водители",
  TITTLE_NAVBAR_MENU_SETTING_CAR_PARK: "Автопарк",
  TITTLE_NAVBAR_MENU_SETTING_CLIENT: "Клиенты",
  TITTLE_HEADER_SEARCH: "Поиск...",
  TITTLE_REQUIRED: "Это поля обьязательно!",
  TITLE_ACTION_TABLE: "Действия",

  //Filters
  TITTLE_FILTER_SEARCH: "Поиск товаров",
  TITTLE_FILTER_DATA: "Фильтр данных",
  TITTLE_FILTER: "Фильтры",
  TITTLE_FILTER_COLS: "Колонки",
  TITTLE_FILTER_INTERVAL: "Интревал дат",
  TITTLE_SELECT_PLACEHOLDER: "Выберите...",
  TITTLE_NO_OPTIONS_PLACEHOLDER: "Нет данных...",
  TITLE_PAGINATION_TABLE_TOTAL_COLUMN: "Всего",
  PAGINATION_OF_TITLE: "из",

  //Home
  TITTLE_HOME_LIST_OF_ORDERS: "Список заказов",
  TITTLE_ORDERS_CREATE_ORDER_MODAL_HEADER: "Создать новый заказ",
  TITTLE_ORDER_MODAL_CLIENT: "Клиент",
  TITTLE_ORDER_MODAL_COMPANY: "Курьерская компания",
  TITTLE_ORDER_MODAL_NAME_SENDER: "Имя отправителя",
  TITTLE_ORDER_MODAL_NAME_RECEIVER: "Имя получателя",

  //Buttons
  TITTLE_BTN_ADD: "Добавить",
  TITTLE_ADD_ZONE: "Добавить зону",
  TITTLE_ADD_OBJECT: "Добавить обьект",
  TITTLE_ZONE: "Зоны",
  TITTLE_LOCATION_OBJECT: "Локации обьектов",
  TITTLE_ROUTES_PAGE_CREATE_ROUTES_BTN: "Построить маршрут",
  TITTLE_ROUTES_PAGE_SPEND: "Провести",
  TITTLE_RELOAD_DATA_FILTER: "Обновить данные",
  TITTLE_FULLSCREEN_FILTER: "На весь экран",
  TITTLE_DOWNLOAD_FILTER: "Скачать",
  TITTLE_PRINT_FILTER: "Распечатать",
  TITLE_ACCEPT_BTN: "Подтвердить",
  TITLE_CANCEL_BTN: "Закрыть",

  //Routes
  TITTLE_ROUTES_PAGE_ROUTES: "Маршруты",
  TITTLE_ROUTES_PAGE_SHOW_ALL: "Показать все",
  TITTLE_ROUTES_PAGE_SHOW_UNALLOCATED: "Показать не распределенные",
  TITTLE_ROUTES_PAGE_RESET_ALL: "Сбросить все",

  //Routes Setting
  TITTLE_ROUTES_SETTING_SWITCH_MAP: "Карты",
  TITTLE_ROUTES_SETTING_SWITCH_TARRIFS: "Тарифы",
  TITTLE_ROUTES_SETTING_SWITCH_TIME_OF_ROUTES: "Время маршрутизации",
  TITTLE_ROUTES_SETTING_SWITCH_TIME_OF_DELIVERY: "Доставка",
  TITTLE_ROUTES_SETTING_SWITCH_SETTING: "Параметры построения",

  //Login
  TITTLE_LOGIN_WELCOME_BACK: "Добро пожаловать !",
  TITTLE_LOGIN_SIGN_IN_TO: "Войдите в Sello logistics, чтобы продолжить",
  TITTLE_LOGIN_EMAIL: "Номер телефона",
  TITTLE_LOGIN_FORGET_PASSWORD: "Забыли пароль ?",
  TITTLE_LOGIN_PASSWORD: "Пароль",
  TITTLE_LOGIN_REMEMBER_ME: "Запомнить меня",
  TITTLE_LOGIN_SIGN_IN: "Войти",
  TITTLE_LOGIN_DONT_HAVE_ACCOUNT: "У нас нет аккаунта ?",
  TITTLE_LOGIN_SIGN_UP: "Зарегистрироваться",
  TITTLE_LOGIN_FOOTER: "Sello Logistics. Созданный с ",
  TITTLE_LOGIN_FOOTER2: "от Tune Consulting",

  //Forget Password
  TITTLE_FORGOT_PASSWORD_ENTER_EMAIL:
    "Введите свой адрес электронной почты, и инструкции будут отправлены вам!",
  TITTLE_FORGOT_PASSWORD_MAIN: "Забыли пароль ?",
  TITTLE_FORGOT_PASSWORD_SEND_RESET: "Отправить ссылку для сброса",
  TITTLE_FORGOT_PASSWORD_I_REMEMBER: "Подождите, я помню свой пароль...",
  TITTLE_FORGOT_CLICK_HERE: "Нажмите сюда",
  TITTLE_FORGOT_RESET_PASSWORD_WITH: "Сброс пароля в Sello Logistics",

  //DRIVER
  TITTLE_EDIT_MODAL_DRIVER: "Изменить водителя",
  TITTLE_ADD_MODAL_DRIVER: "Добваить водителя",
  TITTLE_PRODUCER_MODAL_DRIVER: "Производитель",
  TITTLE_MODEL_MODAL_DRIVER: "Модель",
  TITTLE_TYPE_OF_CAR_MODAL_DRIVER: "Тип транспортного средства",
  TITTLE_TYPE_MODAL_DRIVER: "Тип кузова",
  TITTLE_COLOR_MODAL_DRIVER: "Цвет",
  TITTLE_REGISTER_YEAR_MODAL_DRIVER: "Год регистрации",
  TITTLE_LICENSE_PLATE_MODAL_DRIVER: "Номерный знак",
  TITTLE_STATUS_MODAL_DRIVER: "Статус",
  TITTLE_COURIER_COMPANY_MODAL_DRIVER: "Курьерская компания",
  TITTLE_DRIVER_MODAL_DRIVER: "Водитель",
  TITTLE_CAR_LENGTH_DRIVER: "Длина в кг",
  TITTLE_CAR_WIDTH_DRIVER: "Ширина в кг",
  TITTLE_CAR_HEIGHT_DRIVER: "Высота в кг",

  //NAVBAR
  TITTLE_NAVBAR_MENU_MONITORING: "Мониторинг",
  TITTLE_NAVBAR_MENU_PRODUCTS: "Товары",
  TITTLE_NAVBAR_MENU_SHIPMENT: "Отгрузка",
  TITTLE_NAVBAR_MENU_STAFF: "Персонал",
  TITTLE_NAVBAR_MENU_SETTINGS: "Настройки",
  TITTLE_NAVBAR_MENU_MONITORING_ORDERS: "Заказы",
  TITTLE_NAVBAR_MENU_MONITORING_REMAINS: "Остатки Рц",
  TITTLE_NAVBAR_MENU_MONITORING_HISTORY_CASHBOX: "История касса",
  TITTLE_NAVBAR_MENU_MONITORING_LOAD_ORDERS: "Нагрузка по заказам",
  TITTLE_NAVBAR_MENU_PRODUCTS_ACCEPTANCE: "Приемка",
  TITTLE_NAVBAR_MENU_PRODUCTS_MARKING: "Маркировка",
  TITTLE_NAVBAR_MENU_PRODUCTS_TRAFFIC: "Движение",
  TITTLE_NAVBAR_MENU_PRODUCTS_EQUIPMENT: "Комплектация",
  TITTLE_NAVBAR_MENU_PRODUCTS_STORAGE: "Хранение",
  TITTLE_NAVBAR_MENU_PRODUCTS_ZONES: "Зоны",
  TITTLE_NAVBAR_MENU_PRODUCTS_MOVEMENT: "Перемещение",
  TITTLE_NAVBAR_MENU_PRODUCTS_INVENTORY: "Инвентаризация",
  TITTLE_NAVBAR_MENU_PRODUCTS_PRODUCT_CARDS: "Карточки товаров",
  TITTLE_NAVBAR_MENU_STAFF_SHIFTS: "Смены",
  TITTLE_NAVBAR_MENU_STAFF_PERMISSIONS: "Доступы",
  TITTLE_NAVBAR_MENU_SHIPMENT_CASHBOX: "Касса",
  TITTLE_NAVBAR_MENU_SHIPMENT_ISSUE_CLIENT: "Выдача клиенту",
  TITTLE_NAVBAR_MENU_SHIPMENT_RETURN: "Возврат",
  TITTLE_NAVBAR_MENU_SETTINGS_ADDRESS_STORAGE: "Адресное хранение",
  TITTLE_NAVBAR_MENU_SETTINGS_SETTING_RC: "Параметры РЦ",
  TITTLE_NAVBAR_MENU_SETTINGS_EMPLOYEES: "Сотрудники",

  //PRODUCTS
  TITTLE_PRODUCTS_ACCEPTANCE_OUTFITS_FOR_ARRIVAL: "Наряда к приходу",
  TITTLE_PRODUCTS_ACCEPTANCE_OUTFITS_FOR_SHIPMENT: "Наряда к уходу",
  TITTLE_PRODUCTS_ACCEPTANCE_GOODS_TO_ARRIVAL: "Товары к приходу",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_ARRIVAL: "Приход",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SUPPLIER: "Поставщик",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_AGREEMENT: "Договор",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_PERFORMING_COMPANY: "Компания исполнитель",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_VEHICLE: "Транспортное средство",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_HAND_OVER: "Передал",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_ACCEPTED: "Принял",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SEND_TO_1C: "Отправить в 1С",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_PRINT: "Распечатать",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SAVE: "Сохранить",
  TITTLE_PRODUCTS_ACCEPTANCE_ID_SCAN_YK_PRODUCTS: "Сканировать QR товаров",
};
